// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        suggestionMobileStyle: 'style1'
    }
};

// Override Settings
(function () {  // Add this
  BoostPFS.inject(this);  // Add this

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {  
  };
  
 var bindEvents = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
      bindEvents.call(this);

      var self = this;

      jQ('.header__action-item-link[data-action="toggle-search"]').off('click').click(function(e) {
        e.preventDefault();
        //e.stopPropagation();
        jQ('.search-bar__input').focus();
        self.openSuggestionMobile();
      });
  }
  
  var originalcloseInstantSearchMobile = InstantSearchMobile.prototype.closeInstantSearchMobile;
    InstantSearchMobile.prototype.closeInstantSearchMobile = function(isClose) {
          originalcloseInstantSearchMobile.call(this,isClose);

          // Do your custom code after the original function has run

         jQ('.header__search-bar-wrapper').removeClass('is-fixed');


    }

    InstantSearchApi.beforeCall = function(eventType, eventInfo) {
Globals.instantSearchQueryParams.sort_first = 'available';
Globals.instantSearchQueryParams.product_available = false;
Globals.instantSearchQueryParams.variant_available = false;
 }

})();  // Add this at the end